import { oc } from '@orpc/contract';
import { estimateDetailSchema, reopenEstimateInputSchema } from '../schemas/estimates.schemas.js';
/**
 * Administrator only, and `NO_DEAL` only. `DEAL_AGREED` is never reopened — a stock vehicle exists behind
 * it, and the way to change that record is to correct the vehicle (plan §5.6).
 */
export const reopenEstimateContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/reopen',
    tags: ['Estimates'],
    summary: 'Reopen a no-deal estimate (administrator)',
})
    .input(reopenEstimateInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=reopen-estimate.contract.js.map